<template>
  <div class="time-select">
    <v-select
      :items="getActiveAvailabilities"
      item-text="name"
      item-value="id"
      hint="Select a Time"
      persistent-hint
      dense
      v-model="selectedAvailability"
      placeholder="Preferred Time"
      :append-outer-icon="
        !selectedAvailability ? 'mdi-alert-circle-outline' : null
      "
      :error="!selectedAvailability"
      :error-messages="!selectedAvailability ? ['Select a Time'] : null"
    />
    <v-select
      :items="fulfillmentTypes"
      v-model="fulfillmentType"
      dense
      hint="Preferred Order Type"
      persistent-hint
      :disabled="!selectedAvailability"
      class="my-1"
      input-value="true"
      :placeholder="
        !selectedAvailability ? 'Select a time above' : 'Order Type'
      "
      :error="!fulfillmentType"
      :error-messages="!fulfillmentType ? ['Select an Order Type'] : null"
      :append-outer-icon="!fulfillmentType ? 'mdi-alert-circle-outline' : null"
    >
    </v-select>

    <template v-if="fulfillmentInfo.length && fulfillmentType">
      <AirtableHtml
        tag-class="text-body-2"
        :setting-name="fulfillmentSettingName"
      />
    </template>
    <v-chip-group
      column
      active-class="blue darken-2 white--text"
      v-model="chipSelection"
    >
      <v-chip v-for="slot of availableSlots" :key="slot" small>{{
        slot
      }}</v-chip>
    </v-chip-group>
    <transition name="fade-in-left">
      <v-alert
        v-if="fulfillmentType && !hasSelectedSlot"
        :type="getEmphasizeCartErrors ? 'error' : 'warning'"
        :text="!getEmphasizeCartErrors"
        class="pa-2"
        dense
      >
        <span v-if="getEmphasizeCartErrors" key="alert-time-select">
          You must click the grey button above <br />{{ slotSelectHint }}<br />
          to continue.
        </span>
        <span v-else key="time-select-all-good"
          >Select {{ slotSelectHint }} above</span
        >
      </v-alert>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import AvailabilityModel from '@/models/AvailabilityModel'
import AirtableHtml from '@/components/AirtableHtml'

const FULFILLMENT_TYPES = {
  DELIVERY: 'Delivery',
  PICKUP: 'Pickup',
  SHIPPING: 'Shipping',
}

export default {
  name: 'TimeSelect',
  components: { AirtableHtml },
  data() {
    return {
      chipSelection: null,
    }
  },
  created() {
    this.selectedAvailability = null
  },
  computed: {
    ...mapGetters('cart', [
      'getEmphasizeCartErrors',
      'getFulfillmentType',
      'isDelivery',
    ]),
    ...mapFields('cart', ['selectedAvailability']),
    ...mapGetters('shop', ['getShopDetail', 'getDeliveryFee']),
    ...mapGetters('availabilities', {
      getActiveAvailabilities: 'getActive',
    }),

    fulfillmentType: {
      get() {
        return this.getFulfillmentType
      },
      set(type) {
        this.setFulfillmentType(type)
        if (type === FULFILLMENT_TYPES.DELIVERY) {
          this.setDeliveryFee(this.getDeliveryFee)
        } else {
          this.setDeliveryFee(0)
        }
      },
    },
    selectedAvailabilityModel() {
      // if (!this.selectedAvailability) return
      return AvailabilityModel.find(this.selectedAvailability)
    },
    deliverySlots() {
      if (!this.selectedAvailabilityModel) return []
      return this.selectedAvailabilityModel.delivery_slots
    }, // deliverySlots
    pickupSlots() {
      if (!this.selectedAvailabilityModel) return []
      return this.selectedAvailabilityModel.pickup_slots
    }, // pickupSlots
    availableSlots() {
      if (!this.fulfillmentType) return []
      return this.isDelivery ? this.deliverySlots : this.pickupSlots
    }, // availableSlots
    slotSelectHint() {
      return this.availableSlots.length > 1
        ? `a ${this.fulfillmentType} Slot`
        : `"${this.availableSlots[0]}"`
    },
    selectedSlot() {
      return this.availableSlots[this.chipSelection]
    },
    hasSelectedSlot() {
      return typeof this.chipSelection === 'number'
    }, // hasSelectedSlot
    fulfillmentTypes() {
      if (!this.selectedAvailabilityModel) {
        return []
      }
      let types = []
      if (this.pickupSlots.length) {
        types.push(FULFILLMENT_TYPES.PICKUP)
      }
      if (this.deliverySlots.length) {
        types.push(FULFILLMENT_TYPES.DELIVERY)
      }

      return types
    }, // fulfillmentTypes
    fulfillmentInfo() {
      if (!this.fulfillmentType) return ''
      let type = this.isDelivery
        ? FULFILLMENT_TYPES.DELIVERY
        : FULFILLMENT_TYPES.PICKUP
      return `${type} Info : ${this.getShopDetail(`${type} Info`)}`
    }, // fulfillmentInfo
    fulfillmentSettingName() {
      let type = this.isDelivery
        ? FULFILLMENT_TYPES.DELIVERY
        : FULFILLMENT_TYPES.PICKUP
      return `${type} Info`
    }, // fulfillmentSettingName
  },
  watch: {
    selectedSlot: {
      handler(slot) {
        this.setFulfillmentSlot(slot)
      },
    },
    selectedAvailability: {
      handler(availability) {
        this.setSelectedAvailability(availability)
        this.fulfillmentType = null
        this.chipSelection = null
      },
    },
  },
  methods: {
    ...mapActions('cart', [
      'setFulfillmentSlot',
      'setSelectedAvailability',
      'setFulfillmentType',
      'setDeliveryFee',
    ]),
  },
}
</script>

<style lang="scss">
.fade-in-left-enter-active,
.fade-in-left-leave-active {
  transition: opacity 0.4s, transform 0.4s ease-in-out;
}
.fade-in-left-enter, .fade-in-left-leave-to /* .fade-in-left-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-10px);
}
</style>
